import type { FaireProductEntity } from "../../entity_types/product";

export const p_a6ffupnfc3: FaireProductEntity = {
  token: "p_a6ffupnfc3",
  type: "product",
  name: "Citrus Season Candle",
  brandToken: "b_jx5r7yrney",
  brandName: "Loam Candles",
  imageUrl:
    "https://cdn.faire.com/fastly/73f776646dd9b35e1b9eb9aa7b7b79a3d490c8cda009a7d7b418cdf263325c20.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c400258685185a2c87599eb45f3b532beead7e55996384e73ddbe1d5554264f.jpeg",
    "https://cdn.faire.com/fastly/e3ced60f0c46963a07406f33c32e4d261bef152290e27b3750c8b6d8c5750a5a.jpeg",
    "https://cdn.faire.com/fastly/799d3ab950083c7bae132d15fb59e89202d4be61e83c37b7d9955e2ae7fbf870.jpeg",
  ],
  priceDollars: 16.5,
  description:
    "Scent notes: neroli, sandalwood, kumquat, and yuzu blossoms\n\nWarmed under an early spring sun, delicate neroli blossoms dot the plumes of waxy green citrus leaves, radiating the subtle and luscious scent of honey and life at its peak. Mirroring the neroli blossom, the Citrus Season scent weaves a delicate balance of floral nectar with hints of bright citrus zest in honor of this fragile and elegant flower.\n\nThe vibe: floral, subtly sweet, warm, bright\n\nEvery candle is crafted in small batches with coconut soy wax and 100% cotton wicks. Loam candles are always paraben, paraffin, petroleum, and phthalate-free.",
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:09.894Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
